import { createFileRoute } from "@tanstack/react-router";
import { PageLoading } from "~/components/PageLoading";
import { ClientOnly } from "~/components/ClientOnly";
import { trpc } from "~/utils/trpc.client";
import { ExportTemplateEditor } from "~/app/(new)/[teamId]/students/[studentId]/reports/[reportId]/export-editor/ExportTemplateEditor";

export const Route = createFileRoute(
  "/_authed/$teamId/students/$studentId/reports/$reportId/export-editor",
)({
  component: StudentReportExportEditorPage,
});

function StudentReportExportEditorPage() {
  const { reportId } = Route.useParams();

  // getReportTypeByReportId can fail (no report type) — fail fast and fall back.
  const reportTypeQuery = trpc.reportTypes.getReportTypeByReportId.useQuery(
    { reportId },
    { retry: false },
  );
  const reportQuery = trpc.reports.getReportById.useQuery({ reportId });

  if (reportTypeQuery.isLoading || !reportQuery.data) {
    return (
      <div className="relative h-full whitespace-pre-wrap p-4">
        <PageLoading />
      </div>
    );
  }

  const reportType = reportTypeQuery.data ?? null;
  const report = reportQuery.data;

  if (!reportType) {
    return <div>Report type not found</div>;
  }

  return (
    <div className="relative h-full whitespace-pre-wrap p-4">
      <ClientOnly>
        <ExportTemplateEditor reportType={reportType} report={report} />
      </ClientOnly>
    </div>
  );
}
